<template>
  <div id="flash-message" v-bind:class="type" v-if="show" ref="elem">
    <div class="message" v-html="$t(message)" />
    <div class="close" @click="() => hide()">
      <div class="line line-1" />
      <div class="line line-2" />
    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { TweenMax } from 'gsap';

export default {
  name: 'FlashMessage',
  components: {},
  setup() {
    const store = useStore();

    const show = ref(false);
    const elem = ref(null);

    const isActive = computed(() => store.state.flash.isActive);
    const message = computed(() => store.state.flash.message);
    const type = computed(() => store.state.flash.type);

    const hide = () => {
      store.dispatch('flash/setActiveStatus', false);
    };

    watch(isActive, (newVal) => {
      if (elem.value) {
        if (newVal) {
          show.value = newVal;
        }

        TweenMax.to(elem.value, .2, {
          opacity: +newVal,
          onComplete: () => {
            if (!newVal) {
              show.value = newVal;
            }
          }
        });
      } else {
        show.value = newVal;
      }
    }, {
      immediate: true
    });

    return {
      elem,
      show,
      message,
      type,
      hide
    };
  }
};
</script>

<style scoped lang="scss">
@use "~@/assets/scss/colors" as *;

#flash-message {
  position: fixed;
  top: 15px;
  right: 10px;
  max-width: 400px;
  min-width: 200px;
  border-radius: 2px;
  min-height: 40px;
  background-color: $white;
  color: $black;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  font-weight: bold;
  padding: 12px 30px;
  padding-right: 50px;
  z-index:9999;
  transition: all 0.2s;

  .close {
    position: absolute;
    top: 13px;
    right: 15px;
    width: 15px;
    height: 15px;
    cursor: pointer;
    opacity: .5;
    transition: all .2s ease-in-out;

    .line {
        height: 2px;
        width: 15px;
        background-color: $black;
        transform-origin: center;
        margin: 0 auto;
        transition: all .2s ease-in-out;
    }

    .line-1 {
        transform: translateY(9px) rotate(45deg);
    }

    .line-2 {
        transform: translateY(7.25px) rotate(135deg);
    }

    &:hover {
      opacity: 1;
    }
  }

  @media (max-width: 767px) {
    width: calc(100% - 30px);
  }

  &.info {
    background-color: $white;
    color: $black;
    border: 1px solid $alto;

    .close {
      .line {
        background-color: $black;
      }
    }
  }

  &.error {
    background-color: $blue;
    color: $white;

    .close {
      .line {
        background-color: $white;
      }
    }
  }
}
</style>
